import { LitElement, html, css } from 'lit';
import { fetchPage } from '../lib/api.js';
import '../components/site-page-renderer.js';
import '../components/site-template-renderer.js';

export class SiteCmsPage extends LitElement {
  static properties = {
    slug: { type: String },
    draftMode: { type: Boolean },
    _data: { state: true },
  };

  static styles = css`
    :host {
      display: block;
    }
  `;

  constructor() {
    super();
    this.slug = 'home';
    this.draftMode = false;
    this._data = null;
    this._lastTemplate = 'built-in';
  }

  connectedCallback() {
    super.connectedCallback();
    this._load();
  }

  async _load() {
    const slug = this.slug || 'home';
    try {
      this._data = await fetchPage(slug);
      if (this.draftMode) {
        this.dispatchEvent(new CustomEvent('draft-page-loaded', {
          detail: {
            slug: this._data.slug || slug,
            id: this._data.id,
            title: this._data.title || slug,
            hasUnpublishedChanges: Boolean(this._data.has_unpublished_changes),
            ready: true,
          },
          bubbles: true,
          composed: true,
        }));
      }
    } catch {
      const fallback = (__SITE_FALLBACK__.pages || []).find(page => page.slug === slug);
      this._data = fallback || {
        title: slug,
        content: { schema_version: 1, meta: { headline: 'Content unavailable', subtitle: '', description: '' }, elements: [] },
      };
      if (this.draftMode) {
        this.dispatchEvent(new CustomEvent('draft-page-loaded', {
          detail: { slug, title: slug, hasUnpublishedChanges: false, ready: false },
          bubbles: true,
          composed: true,
        }));
      }
    }
  }

  updated(changed) {
    if (changed.has('slug') || changed.has('draftMode')) {
      this._load();
    }
    if (changed.has('_data')) {
      const template = this._data?.content?.template || 'built-in';
      if (template !== this._lastTemplate) {
        this._lastTemplate = template;
        this.dispatchEvent(new CustomEvent('template-changed', {
          detail: { template, slug: this._data?.slug || this.slug },
          bubbles: true,
          composed: true,
        }));
      }
    }
  }

  render() {
    const content = this._data?.content;
    const template = content?.template || 'built-in';
    if (template !== 'built-in') {
      return html`
        <site-template-renderer
          .template=${template}
          .content=${content}
          .title=${this._data?.title || ''}
        ></site-template-renderer>
      `;
    }
    return html`<site-page-renderer .content=${content} .title=${this._data?.title || ''}></site-page-renderer>`;
  }
}

customElements.define('site-cms-page', SiteCmsPage);
